module.exports = __webpack_public_path__ + "img/xb_icon04.8eb3f9cc.png";